const THREE = require('three')
import camera from './camera'

export let listener = new THREE.AudioListener()
export default listener
// listener.setMasterVolume(0.01)

camera.add(listener)




// WEBPACK FOOTER //
// ./src/components/game/listener.js